import { Component } from '@theme/component';

/**
 * A pulsing product hotspot that opens the shared quick-add dialog directly
 * on click/tap, regardless of breakpoint - no intermediate hover popover.
 *
 * @extends Component
 */
export class LookbookHotspotComponent extends Component {
  requiredRefs = ['trigger'];

  /**
   * Opens the quick-add dialog for this hotspot's product.
   * @param {MouseEvent} event - The click event.
   */
  handleClick(event) {
    event.preventDefault();

    const quickAddComponent = this.querySelector('quick-add-component');
    if (!quickAddComponent) return;

    quickAddComponent.handleClick(new MouseEvent('click', { bubbles: true, cancelable: true }));
  }

  /**
   * Gets the product link for this hotspot's product, used by QuickAddComponent
   * to resolve which product page to fetch into the quick-add dialog.
   * @returns {HTMLAnchorElement | null} The product link or null.
   */
  getHotspotProductLink() {
    return this.refs.productLink || null;
  }
}

if (!customElements.get('lookbook-hotspot-component')) {
  customElements.define('lookbook-hotspot-component', LookbookHotspotComponent);
}
